if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
          isExpanded: 'is-expanded'
        };

        this.onCartUpdated = this.onCartUpdated.bind(this);
        this.onCartNotification = this.onCartNotification.bind(this);
        this.onVariantChanged = this.onVariantChanged.bind(this);
      }

      get submitEls() {
        return this.querySelectorAll('button[name="add"], .sticky-atc-bar__mobile-submit, .product-form__submit');
      }

      get productForm() {
        const formId = this.dataset.formId || this.getAttribute('data-form-id');
        if (formId) {
          const form = document.getElementById(formId);
          if (form) return form;
        }
        return document.querySelector('.product-form form') || document.querySelector('form[action*="/cart/add"]');
      }

      connectedCallback() {
        const wrapper = this.closest('.sticky-atc-bar__gradient-wrapper') || this;
        if (wrapper && wrapper.parentElement && wrapper.parentElement !== document.body) {
          console.log('[StickyATC Debug] 检测到处于 Section 内部，正在自动提升挂载到 document.body 根节点...');
          document.body.appendChild(wrapper);
          return;
        }

        this.targetObserver =
          document.querySelector('.product-form__buy-buttons') ||
          document.querySelector('.product-form__payment-container') ||
          this.productForm;

        this.submitEls.forEach((btn) => {
          btn.addEventListener('click', this.onClick.bind(this));
        });

        this.init();

        document.documentElement.addEventListener('cart:updated', this.onCartUpdated);
        document.addEventListener('variant:added', this.onCartUpdated);
        document.addEventListener('cart-notification:show', this.onCartNotification);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }

        if (this.mobileResizeObserver) {
          this.mobileResizeObserver.disconnect();
        }

        document.documentElement.removeEventListener('cart:updated', this.onCartUpdated);
        document.removeEventListener('variant:added', this.onCartUpdated);
        document.removeEventListener('cart-notification:show', this.onCartNotification);
        document.removeEventListener('variant:changed', this.onVariantChanged);
      }

      onCartUpdated() {
        this.resetButtonLoading();
        this.querySelectorAll('input[name="quantity"]').forEach((input) => {
          input.value = 1;
          input.dispatchEvent(new CustomEvent('change', { detail: { preventScroll: true }, bubbles: true }));
        });
      }

      onCartNotification() {
        this.resetButtonLoading();
      }

      initMobileImageResize() {
        this.mobileInfo = this.querySelector('.sticky-atc-bar__mobile-info');
        this.mobileImageWrapper = this.querySelector(
          '.sticky-atc-bar__mobile-product-details .sticky-atc-bar__product-image'
        );
        this.mobileImage = this.mobileImageWrapper?.querySelector('img');
        this.mobileContainer = this.querySelector('.sticky-atc-bar__mobile-product-details');

        if (!this.mobileInfo || !this.mobileImage || !this.mobileContainer) return;

        this.mobileResizeObserver = new ResizeObserver(() => {
          this.updateMobileImageSize();
        });

        this.mobileResizeObserver.observe(this.mobileInfo);
        this.mobileResizeObserver.observe(this.mobileContainer);
      }

      updateMobileImageSize() {
        if (!this.classList.contains(this.classes.isExpanded)) return;
        if (this.mobileImage) {
          this.mobileImage.style.width = '100%';
          this.mobileImage.style.height = '100%';
        }
      }

      init() {
        if (!this.targetObserver) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isNotVisible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle(this.classes.isOpen, isNotVisible);
              if (this.parentElement && this.parentElement.classList.contains('sticky-atc-bar__gradient-wrapper')) {
                this.parentElement.classList.toggle('sticky-atc-bar--show', isNotVisible);
                this.parentElement.classList.toggle('is-visible', isNotVisible);
              }
            });
          },
          { threshold: 0, rootMargin: '0px' }
        );
        this.observer.observe(this.targetObserver);

        this.syncWithMainProductForm();
        this.bindVariantSelectors();
        this.bindCustomSelects();
        this.bindMobileToggle();
        this.initMobileImageResize();
        this.bindQuantitySync();
      }


      bindCustomSelects() {
        const customSelects = this.querySelectorAll('.sticky-atc-bar__custom-select');

        customSelects.forEach((select) => {
          const trigger = select.querySelector('.sticky-atc-bar__custom-select-trigger');
          const dropdown = select.querySelector('.sticky-atc-bar__custom-select-dropdown');
          const input = select.querySelector('.sticky-atc-bar__custom-select-input');
          const label = select.querySelector('.sticky-atc-bar__custom-select-label');
          const triggerSwatch = select.querySelector('.sticky-atc-bar__custom-select-trigger .swatch-color');
          const items = select.querySelectorAll('.sticky-atc-bar__custom-select-item');

          if (!trigger || !dropdown) return;

          // Toggle dropdown
          trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            // Close all other dropdowns
            this.querySelectorAll('.sticky-atc-bar__custom-select-trigger[aria-expanded="true"]').forEach((btn) => {
              btn.setAttribute('aria-expanded', 'false');
              const dd = btn.closest('.sticky-atc-bar__custom-select')?.querySelector('.sticky-atc-bar__custom-select-dropdown');
              if (dd) dd.classList.add('hidden');
            });

            if (!isExpanded) {
              trigger.setAttribute('aria-expanded', 'true');
              dropdown.classList.remove('hidden');
            }
          });

          // Handle Selection
          items.forEach((item) => {
            item.addEventListener('click', (e) => {
              e.stopPropagation();

              items.forEach((sib) => sib.classList.remove('is-selected'));
              item.classList.add('is-selected');

              const newValue = item.dataset.value;
              if (input) input.value = newValue;
              if (label) label.textContent = newValue;

              const swatchBg = item.dataset.swatch;
              if (triggerSwatch) {
                if (swatchBg) {
                  triggerSwatch.style.cssText = `--swatch-background: ${swatchBg}; width: 20px; height: 20px; box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1), 0 0 0 2px rgb(var(--color-background, 255, 255, 255)), 0 0 0 3px rgb(var(--color-foreground, 0, 0, 0));`;
                  triggerSwatch.classList.remove('hidden');
                } else {
                  triggerSwatch.classList.add('hidden');
                }
              }

              trigger.setAttribute('aria-expanded', 'false');
              dropdown.classList.add('hidden');

              // Sync to main form
              this.syncOptionToMainForm(input?.dataset.optionName, newValue, input?.dataset.optionIndex);

              // Update mobile option value label if exists
              const mobileOptionWrapper = select.closest('.sticky-atc-bar__mobile-option');
              if (mobileOptionWrapper) {
                const valLabel = mobileOptionWrapper.querySelector('.sticky-atc-bar__mobile-val');
                if (valLabel) valLabel.textContent = newValue;
              }
            });
          });
        });

        // Click outside to close
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.sticky-atc-bar__custom-select')) {
            this.querySelectorAll('.sticky-atc-bar__custom-select-trigger[aria-expanded="true"]').forEach((btn) => {
              btn.setAttribute('aria-expanded', 'false');
              const dd = btn.closest('.sticky-atc-bar__custom-select')?.querySelector('.sticky-atc-bar__custom-select-dropdown');
              if (dd) dd.classList.add('hidden');
            });
          }
        });
      }

      bindMobileToggle() {
        const toggleBtn = this.querySelector('.sticky-atc-bar__mobile-toggle');
        const closeBtn = this.querySelector('.sticky-atc-bar__mobile-close');

        if (toggleBtn && closeBtn) {
          const toggleExpand = () => {
            this.classList.toggle(this.classes.isExpanded);
            if (this.classList.contains(this.classes.isExpanded)) {
              setTimeout(() => this.updateMobileImageSize(), 0);
            }
          };
          toggleBtn.addEventListener('click', toggleExpand);
          closeBtn.addEventListener('click', toggleExpand);
        }
      }

      syncOptionToMainForm(optionName, value, optionIndex) {
        const currentScrollY = window.scrollY;
        const currentScrollX = window.scrollX;
        window.__preventVariantScrollToTop = true;

        const formId = this.dataset.formId || this.getAttribute('data-form-id');
        const scope = (formId ? document.querySelector(`product-variants[form-id="${formId}"]`) : null) ||
                      document.querySelector('product-variants') ||
                      this.productForm ||
                      document;

        const escapedValue = CSS.escape(value);
        const position = typeof optionIndex !== 'undefined' ? parseInt(optionIndex, 10) + 1 : null;

        let matchingOption = null;
        if (position) {
          matchingOption = scope.querySelector(
            `input[name="option${position}"][value="${escapedValue}"], select[name="option${position}"] option[value="${escapedValue}"]`
          );
        }

        if (!matchingOption) {
          matchingOption = scope.querySelector(
            `input[type="radio"][value="${escapedValue}"], select option[value="${escapedValue}"]`
          );
        }

        if (matchingOption) {
          if (matchingOption.tagName === 'OPTION') {
            const parentSelect = matchingOption.closest('select');
            if (parentSelect && parentSelect.value !== value) {
              parentSelect.value = value;
              parentSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (matchingOption.tagName === 'INPUT') {
            if (!matchingOption.checked) {
              matchingOption.checked = true;
              matchingOption.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        // 保持视口静止，防止第三方轮播组件或焦点引起页面跳动
        const restoreScroll = () => {
          if (window.scrollY !== currentScrollY || window.scrollX !== currentScrollX) {
            window.scrollTo({ top: currentScrollY, left: currentScrollX, behavior: 'instant' });
          }
        };
        requestAnimationFrame(restoreScroll);
        setTimeout(restoreScroll, 50);
        setTimeout(restoreScroll, 150);
        setTimeout(() => {
          restoreScroll();
          window.__preventVariantScrollToTop = false;
        }, 350);
      }

      bindQuantitySync() {
        const syncAll = (val, origin) => {
          const allInputs = document.querySelectorAll('input[name="quantity"]');
          allInputs.forEach((input) => {
            if (input !== origin && input.value !== val) {
              input.value = val;
              input.dispatchEvent(new CustomEvent('change', { detail: { preventScroll: true }, bubbles: true }));
            }
          });

          // Sync with theme quantity event
          const formId = this.dataset.formId || this.getAttribute('data-form-id');
          if (formId) {
            document.documentElement.dispatchEvent(
              new CustomEvent('quantity:updated', {
                bubbles: true,
                detail: { form: formId, quantity: parseInt(val, 10) || 1 }
              })
            );
          }
        };

        // Minus / Plus buttons within the sticky bar
        this.querySelectorAll('.quantity__button, .quantity-selector__button').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const wrapper = btn.closest('.quantity, .quantity-selector');
            const input = wrapper?.querySelector('input[name="quantity"]');
            if (!input) return;

            let currentVal = parseInt(input.value, 10) || 1;
            const isMinus = btn.getAttribute('name') === 'minus' || btn.classList.contains('quantity-selector__button--minus') || btn === wrapper.firstElementChild;

            if (isMinus) {
              currentVal = Math.max(1, currentVal - 1);
            } else {
              currentVal = currentVal + 1;
            }

            input.value = currentVal;
            syncAll(currentVal.toString(), input);
          });
        });

        // Event delegation for input change
        document.addEventListener('change', (e) => {
          if (e.target.matches('input[name="quantity"]')) {
            syncAll(e.target.value, e.target);
          }
        });

        document.addEventListener('input', (e) => {
          if (e.target.matches('input[name="quantity"]')) {
            syncAll(e.target.value, e.target);
          }
        });
      }

      bindVariantSelectors() {
        const selects = this.querySelectorAll('.sticky-atc-bar__variant-select');
        selects.forEach((select) => {
          select.addEventListener('change', (e) => {
            this.syncOptionToMainForm(e.target.dataset.optionName, e.target.value, e.target.dataset.optionIndex);
          });
        });

        const radios = this.querySelectorAll('.sticky-atc-bar__variant-radio');
        radios.forEach((radio) => {
          radio.addEventListener('change', (e) => {
            if (e.target.checked) {
              this.syncOptionToMainForm(e.target.dataset.optionName, e.target.value, e.target.dataset.optionIndex);
              const optionWrapper = e.target.closest('.sticky-atc-bar__mobile-option');
              if (optionWrapper) {
                const valLabel = optionWrapper.querySelector('.sticky-atc-bar__mobile-val');
                if (valLabel) valLabel.textContent = e.target.value;
              }
            }
          });
        });
      }

      onClick(e) {
        this.submitEls.forEach((btn) => {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('aria-busy', 'true');
          btn.classList.add('btn--loading');
        });

        // If the button clicked is not natively tied to the form, trigger submit on main form
        const form = this.productForm;
        if (form && !e.target.closest('form')) {
          e.preventDefault();
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        }
      }

      resetButtonLoading() {
        this.submitEls.forEach((btn) => {
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('aria-busy');
          btn.classList.remove('btn--loading');
        });
      }

      updateImage(variant) {
        if (!variant || !variant.featured_image) return;
        const imgNodes = this.querySelectorAll('.sticky-atc-bar__product-image img');
        if (!imgNodes.length) return;
        const src = variant.featured_image.src || variant.featured_image.url;
        if (!src) return;

        imgNodes.forEach((imgNode) => {
          imgNode.setAttribute('src', src);
          imgNode.setAttribute('srcset', src);
        });
      }

      updateButton(disable = true, text = '') {
        const defaultText =
          window.themeVariables?.strings?.productFormAddToCart ||
          this.getAttribute('data-add-to-cart-text') ||
          'Add to cart';

        this.submitEls.forEach((addButton) => {
          if (!addButton) return;
          const addButtonText = addButton.querySelector('.loader-button__text, .btn__text') || addButton.firstElementChild || addButton;
          if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute('disabled');
            if (addButtonText) addButtonText.textContent = defaultText;
          }
        });
      }

      formatMoney(cents, format = '') {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || window.themeVariables?.settings?.moneyFormat || '${{amount}}';

        function defaultOption(opt, def) {
          return typeof opt === 'undefined' ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) {
            return '0.00';
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          const centsVal = parts[1] ? decimal + parts[1] : '';

          return dollars + centsVal;
        }

        const match = formatString.match(placeholderRegex);
        const formatType = match ? match[1] : 'amount';

        switch (formatType) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          default:
            value = formatWithDelimiters(cents, 2);
        }

        return formatString.replace(placeholderRegex, value);
      }

      updatePrice(variant) {
        if (!variant) return;

        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out'
        };
        const moneyFormat = window.themeVariables?.settings?.moneyFormat || '';
        const { compare_at_price, price } = variant;

        const priceWrappers = this.querySelectorAll('.f-price');
        priceWrappers.forEach((priceWrapper) => {
          if (compare_at_price && compare_at_price > price) {
            priceWrapper.classList.add(classes.onSale);
          } else {
            priceWrapper.classList.remove(classes.onSale);
          }

          if (!variant.available) {
            priceWrapper.classList.add(classes.soldOut);
          } else {
            priceWrapper.classList.remove(classes.soldOut);
          }

          const salePrice = priceWrapper.querySelector('.f-price-item--sale');
          if (salePrice) salePrice.innerHTML = this.formatMoney(price, moneyFormat);

          const compareAtPrices = priceWrapper.querySelectorAll('.f-price-item--regular');
          if (compareAtPrices.length > 0) {
            if (compare_at_price && compare_at_price > price) {
              compareAtPrices.forEach((item) => {
                item.innerHTML = `<s>${this.formatMoney(compare_at_price, moneyFormat)}</s>`;
              });
            } else {
              compareAtPrices.forEach((item) => {
                item.innerHTML = this.formatMoney(price, moneyFormat);
              });
            }
          }
        });

        // Update SAVE badges
        const saveBadges = this.querySelectorAll('.sticky-atc-bar__save-badge');
        saveBadges.forEach((badge) => {
          if (compare_at_price && compare_at_price > price) {
            const saveAmount = compare_at_price - price;
            const savePriceEl = badge.querySelector('.sticky-atc-bar__save-price');
            if (savePriceEl) {
              savePriceEl.innerHTML = this.formatMoney(saveAmount, moneyFormat);
            }
            badge.classList.remove('hidden');
          } else {
            badge.classList.add('hidden');
          }
        });

        // Update Mobile Collapsed Price
        const mobileCollapsedPrice = this.querySelector('.sticky-atc-bar__mobile-collapsed-price');
        if (mobileCollapsedPrice) {
          mobileCollapsedPrice.innerHTML = this.formatMoney(price, moneyFormat);
        }
      }

      onVariantChanged(event) {
        const variant = event.detail?.variant;
        if (!variant) {
          const unavailableText = window.themeVariables?.strings?.productFormUnavailable || 'Unavailable';
          this.updateButton(true, unavailableText);
          return;
        }

        this.updatePrice(variant);
        this.updateImage(variant);
        this.updateStickySelectors(variant);

        if (!variant.available) {
          const soldOutText = window.themeVariables?.strings?.productFormSoldOut || 'Sold out';
          this.updateButton(true, soldOutText);
        } else {
          this.updateButton(false);
        }
      }

      syncWithMainProductForm() {
        document.addEventListener('variant:changed', this.onVariantChanged);
      }

      updateStickySelectors(variant) {
        if (!variant || !variant.options) return;

        variant.options.forEach((optionValue, idx) => {
          // Update Custom Dropdowns (Desktop & Mobile)
          const customWrappers = this.querySelectorAll(`.sticky-atc-bar__option-wrap[data-option-index="${idx}"]`);
          customWrappers.forEach((customWrapper) => {
            const input = customWrapper.querySelector('.sticky-atc-bar__custom-select-input');
            const items = customWrapper.querySelectorAll('.sticky-atc-bar__custom-select-item');
            const label = customWrapper.querySelector('.sticky-atc-bar__custom-select-label');
            const triggerSwatch = customWrapper.querySelector('.sticky-atc-bar__custom-select-trigger .swatch-color');

            if (input && input.value !== optionValue) {
              input.value = optionValue;
              if (label) label.textContent = optionValue;

              items.forEach((item) => {
                if (item.dataset.value === optionValue) {
                  item.classList.add('is-selected');
                  const swatchBg = item.dataset.swatch;
                  if (triggerSwatch) {
                    if (swatchBg) {
                      triggerSwatch.style.cssText = `--swatch-background: ${swatchBg}; width: 20px; height: 20px; box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1), 0 0 0 2px rgb(var(--color-background, 255, 255, 255)), 0 0 0 3px rgb(var(--color-foreground, 0, 0, 0));`;
                      triggerSwatch.classList.remove('hidden');
                    } else {
                      triggerSwatch.classList.add('hidden');
                    }
                  }
                } else {
                  item.classList.remove('is-selected');
                }
              });
            }

            const valLabel = customWrapper.querySelector('.sticky-atc-bar__mobile-val');
            if (valLabel) valLabel.textContent = optionValue;
          });

          // Update Radios (Desktop & Mobile)
          const radios = this.querySelectorAll(`.sticky-atc-bar__variant-radio[data-option-index="${idx}"]`);
          radios.forEach((radio) => {
            if (radio.value === optionValue) {
              radio.checked = true;
              const valLabel = radio.closest('.sticky-atc-bar__mobile-option')?.querySelector('.sticky-atc-bar__mobile-val');
              if (valLabel) valLabel.textContent = optionValue;

              // Update Desktop Selected Color Label if applicable
              const desktopWrap = radio.closest('.sticky-atc-bar__option-wrap--color');
              if (desktopWrap) {
                const selectedValSpan = desktopWrap.querySelector('.sticky-atc-bar__selected-val');
                if (selectedValSpan) selectedValSpan.textContent = optionValue;
              }

              // Update Collapsed Mobile Swatch if this option is color
              const optName = (radio.dataset.optionName || radio.name || '').toLowerCase();
              const isColorOpt = optName.includes('color') || optName.includes('colour');
              if (isColorOpt) {
                const swatchLabel = radio.nextElementSibling || radio.closest('label') || radio.parentElement?.querySelector('label');
                const swatchSpan = swatchLabel?.querySelector('.swatch-color');
                const collapsedSwatch = this.querySelector('.sticky-atc-bar__collapsed-swatch');
                if (swatchSpan && collapsedSwatch) {
                  const bg = swatchSpan.style.getPropertyValue('--swatch-background') || swatchSpan.style.backgroundImage || swatchSpan.style.backgroundColor;
                  if (bg) {
                    collapsedSwatch.style.setProperty('--swatch-background', bg);
                    collapsedSwatch.classList.remove('hidden');
                  }
                }
              }
            }
          });

          // Update Mobile Selects
          const selects = this.querySelectorAll(`.sticky-atc-bar__variant-select[data-option-index="${idx}"]`);
          selects.forEach((select) => {
            if (select && select.value !== optionValue) {
              select.value = optionValue;
            }
          });
        });

        const summary = this.querySelector('.sticky-atc-bar__mobile-summary');
        if (summary) {
          summary.textContent = variant.title;
        }
      }
    }
  );
}
